import React from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { upsertIncidentDetectionLapseReview } from "../../incidentDetectionLapseReview/logic/thunk";
import { selectIncidentDetectionLapseReview } from "../../incidentDetectionLapseReview/logic/slice";
import { showErrorToast } from "../../../lib/toast";
import EditableRemarksSection from "../../../components/ui/remarks/EditableRemarksSection";

type NonDetectionField = "reasons_for_non_detection" | "non_detection_actions";

const AuditsNonDetectionDetails: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const incidentDetectionLapseReview = useAppSelector(selectIncidentDetectionLapseReview);

  const handleSave = async (field: NonDetectionField, value: string) => {
    if (!caseId) {
      showErrorToast("Case ID is missing.");
      return;
    }

    try {
      await dispatch(
        upsertIncidentDetectionLapseReview({
          caseId,
          data: { [field]: value },
        }),
      ).unwrap();
    } catch {
      showErrorToast("Failed to save details. Please try again.");
    }
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <EditableRemarksSection
        title="Reasons for non detection"
        subtitle="Why the fraud could not have been detected during internal inspection/ audit (including concurrent audit)"
        value={incidentDetectionLapseReview?.reasons_for_non_detection ?? ""}
        onSave={(value) => handleSave("reasons_for_non_detection", value)}
      />

      <EditableRemarksSection
        title="Actions for non detection"
        subtitle="What actions have been taken for non-detection of the fraud during such inspections/audits"
        value={incidentDetectionLapseReview?.non_detection_actions ?? ""}
        onSave={(value) => handleSave("non_detection_actions", value)}
      />
    </div>
  );
};

export default AuditsNonDetectionDetails;
